export const ExternalMessages = {
    CONFIGURATOR_UPDATE: "CONFIGURATOR_UPDATE",
};
